module.exports = __webpack_public_path__ + "img/Sylva.80f78043.png";